<template>
  <p>
    <label for="additionalcosts">{{$store.getters.translations.service_charges}}</label>
    <input @change="changeValue" v-bind:value="additionalCosts" disabled type="text" id="additionalcosts" >
  </p>
  <slider v-bind:value="additionalCosts"
          v-bind:min="0"
          v-bind:disabled="true"
          @slider-change="sliderChangeValue"></slider>
  <a href="" :class="{ sublink: true, attention: attention }" @click.prevent="showCalculator">{{$store.getters.translations.show_calculator_button_text}}</a>
</template>

<script>
import Slider from "./Slider";
export default {
  name: "AdditionalCosts",
  components: {Slider},
  props:['additionalCosts','sellingPriceChanged'],
  emits:['change-additional-costs','show-modal'],
  data:function () {
    return {
      attention:false
    };
  },
  watch:{
    sellingPriceChanged(value){
      const newButtonText  = value ?
          this.$store.getters.translations.adjust_service_charges_now:
          this.$store.getters.translations.service_charge_calculator;

      this.$store.commit('changeCalculatorButtonText',newButtonText);
      this.attention = value;
    }
  },
  methods:{
    changeValue(event){
      this.$emit('change-additional-costs',event.target.value);
    },
    sliderChangeValue(value){
      this.$emit('change-additional-costs',value);
    },
    showCalculator(){
      this.$emit('show-modal');
    }
  }
}
</script>
